module.exports = __webpack_public_path__ + "static/media/falemais.a573482d.png";